<template>
  <div class="content-page">
    <div class="tab-header">
      <el-button type="primary" size="medium" @click="addGroupPurcharse"
        >新增拼团</el-button
      >
      <el-button type="primary" size="medium" @click="addBDSHGroupPurcharse"
        >新增本地生活团购</el-button
      >
    </div>
    <div class="tab-content">
      <el-table :data="activeList" style="width: 100%" :max-height="550">
        <el-table-column align="left" prop="activityName" label="商品"></el-table-column>
        <el-table-column align="center" prop="startTime" label="拼团时间" width="300">
          <template slot-scope="scope">
            {{ scope.row.startTime }} 至 {{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="groupNow" label="已参团"></el-table-column>
        <el-table-column
          align="center"
          prop="finishCount"
          label="已成团"
        ></el-table-column>
        <el-table-column align="center" prop="count" label="参团库存"></el-table-column>
        <el-table-column align="center" prop="price" label="团购价格"></el-table-column>
        <el-table-column align="center" prop="isRecommend" label="推荐">
          <template slot-scope="scope">
            {{
              scope.row.isRecommend == 1 ? "是" : scope.row.isRecommend == 0 ? "否" : ""
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="changeStatus(scope.row)">{{
              scope.row.isRecommend == 1
                ? "不推荐"
                : scope.row.isRecommend == 0
                ? "推荐"
                : ""
            }}</el-button>
            <el-button type="primary" size="small" @click="lookDetail(scope.row)"
              >查看</el-button
            >
            <el-button type="primary" size="small" @click="updateActive(scope.row)"
              >编辑</el-button
            >
            <el-button type="danger" size="small" @click="delActive(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="activeList.length > 0" style="padding-left: 15px">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="queryInfo.row"
        :current-page="queryInfo.pageNo"
        background
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  Marketing_activityList,
  getActivityListTotalNum,
  deleteActivity,
  isRecommendActivity,
} from "../api/index";
export default {
  data() {
    return {
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      activeList: [],
    };
  },
  mounted() {
    this.getMarketing_activityList();
  },
  methods: {
    getMarketing_activityList() {
      Marketing_activityList({
        activityType: 1,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
      }).then((res) => {
        getActivityListTotalNum({
          activityType: 1,
          pageNo: this.queryInfo.pageNo,
          row: this.queryInfo.row,
        }).then((res) => {
          if (res.code == 1) {
            this.total = res.data.totalNum;
          } else {
            this.total = 0;
          }
        });
        if (res.code == 1) {
          this.activeList = res.data;
        } else if (res.code == -1) {
          this.activeList = [];
        } else {
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      this.getMarketing_activityList();
    },
    changeStatus(row) {
      console.log(row.isRecommend);
      this.$confirm("此操作将更改状态, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        isRecommendActivity({
          activityId: row.activityId,
          isRecommend: row.isRecommend == 1 ? 0 : row.isRecommend == 0 ? 1 : "",
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "更改成功",
              type: "success",
              duration: 1000,
            });
            this.getMarketing_activityList();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
    lookDetail(row) {
      console.log(row, "lookDetail");
      localStorage.setItem("activityId", row.activityId);
      this.$router.push("/groupPurchase/detail");
    },
    addGroupPurcharse() {
      this.$router.push("/groupPurchase/addAndEdit?activityType=1");
    },
    addBDSHGroupPurcharse() {
      this.$router.push("/groupPurchase/addAndEdit?activityType=7");
    },
    updateActive(row) {
      console.log(row, "updateActive");
      localStorage.setItem("updateActivityId", row.activityId);
      this.$router.push(`/groupPurchase/addAndEdit`);
    },
    delActive(row) {
      console.log(row, "delActive");
      this.$confirm("此操作将永久删除该商品, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        deleteActivity({
          activityId: row.activityId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            this.getMarketing_activityList();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
  }
  .tab-content {
    // width: calc(100vw - 280px);
    padding: 0 15px;
  }
}
</style>
